import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import store from "./redux/store";
import App from "./App";
import { BrowserRouter as Router, Route } from "react-router-dom";
import * as Sentry from "@sentry/browser";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";

//process.env.NODE_ENV === "development" ||
if (
  window.location.hostname === "r2gustavetjanst.studieforbunden.se" ||
  window.location.hostname === "r1gustavetjanst.studieforbunden.se" ||
  window.location.hostname === "devgustavetjanst.studieforbunden.se"
) {
  Sentry.init({
    dsn: "https://ead3644b27764500a75d93001b2240c6@app.glitchtip.com/138",
  });
}
const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <Router>
      <Route path="/" component={App} />
    </Router>
  </Provider>
);
